/** Aviso de que a visibilidade dos elementos mudou (esconder, isolar,
 *  mostrar tudo, fantasma).
 *
 *  O `hiddenCount` do store não chega: isolar outro elemento com o mesmo
 *  número de escondidos não o muda. Quem precisa de saber QUE elementos
 *  se vêem (o preenchimento dos cortes) ouve isto. Ficheiro à parte para
 *  não criar ciclos de import com o viewerApi. */

const ouvintes = new Set<() => void>()

export function ouvirMudancaDeVisibilidade(cb: () => void): () => void {
  ouvintes.add(cb)
  return () => {
    ouvintes.delete(cb)
  }
}

export function avisarMudancaDeVisibilidade(): void {
  for (const cb of ouvintes) {
    try {
      cb()
    } catch (err) {
      console.warn('[visibilidade] ouvinte falhou', err)
    }
  }
}
